<template>
  <div>
    <div :class="`select-teeth-wrap ${disabled ? 'disabled' : ''}`" v-html="svg"></div>
    <v-layout>
      <v-autocomplete
        v-model="teeth"
        :items="codes"
        multiple
        chips
        clearable
        deletable-chips
        :small-chips="teeth.length > 8"
        :disabled="disabled"
        :error-messages="errorMessages"
        @change="$emit('change', $event)"
      />
      <v-menu offset-y open-on-hover class="invert-wrap" v-if="!disabled">
        <v-btn
          slot="activator"
          color="primary"
          dark
          shrink
        >
          Invert
          <v-icon right>fas fa-caret-down</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click="invert(0, 31)">
            <v-list-tile-title>Adult</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="invert(32, 51)">
            <v-list-tile-title>Children</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="invert(0, 51)">
            <v-list-tile-title>All</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-layout>
    <div></div>
    <div
      v-if="hover.show"
      :style="`left: ${hover.x+15}px; top: ${hover.y+15}px;`"
      class="select-teeth-hover"
    >
      {{ hover.text }}
    </div>
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual';
import svgUrl from '../../assets/teeth.svg';
import codes from '@/lib/teeth-codes';

export default {
  props: {
    value: { type: Array, default: () => [] },
    disabled: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      svg: '',
      teeth: this.value || [],
      teethEl: [],
      codes,
      hover: {
        show: false,
        x: 0,
        y: 0,
        text: '',
      },
    };
  },
  methods: {
    toggle(t) {
      if (this.disabled) return;
      const i = this.teeth.indexOf(t);
      if (i === -1) this.teeth.push(t);
      else this.teeth.splice(i, 1);
    },
    invert(a, b) {
      for (let i = a; i <= b; i += 1) this.toggle(codes[i]);
    },
    show(e, text) {
      this.hover.x = e.clientX;
      this.hover.y = e.clientY;
      this.hover.text = text;
      this.$nextTick(() => {
        this.hover.show = true;
      });
    },
    initSVG() {
      this.$nextTick(() => {
        if (!document.getElementById('tooth11')) return;
        this.teethEl = codes.map((t) => {
          const tel = document.getElementById(`tooth${t}`);
          tel.addEventListener('click', () => this.toggle(t));
          tel.addEventListener('mousenter', e => this.show(e, `${t}`));
          tel.addEventListener('mousemove', e => this.show(e, `${t}`));
          tel.addEventListener('mouseleave', () => { this.hover.show = false; });
          return tel;
        });
        codes.forEach((t, i) => {
          this.teethEl[i].classList.toggle('active', this.teeth.indexOf(t) !== -1);
        });
      });
    },
  },
  async mounted() {
    const res = await fetch(svgUrl);
    this.svg = await res.text();
    this.initSVG();
  },
  watch: {
    teeth() {
      if (this.teethEl.length) {
        codes.forEach((t, i) => {
          this.teethEl[i].classList.toggle('active', this.teeth.indexOf(t) !== -1);
        });
      }
      if (!isEqual(this.teeth, this.value)) this.$emit('input', this.teeth);
    },
    value() {
      this.teeth = this.value;
    },
  },
};
</script>

<style lang="stylus">
.select-teeth-wrap
  text-align center
  svg
    width 70%
    max-width 450px
    height auto
    display inline-block
    path.select-teeth:hover,
    path.select-teeth.active
      cursor pointer
      fill: #796bb2!important
    path:not(.select-teeth)
      pointer-events none
.select-teeth-wrap.disabled
  svg
    path.select-teeth:hover,
    path.select-teeth.active
      cursor default
.select-teeth-hover
  position fixed
  color white
  background-color rgba(0, 0, 0, 0.7)
  padding 0.75em 1em
  border-radius 4px
.invert-wrap
  display flex
  align-items center
</style>
